import { frontendURL } from '../../../helper/URLHelper';

const ClawAgentsView = () => import('./ClawAgentsView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/claw-agents'),
    name: 'claw_agents_view',
    meta: {
      permissions: ['administrator'],
    },
    component: ClawAgentsView,
  },
];
